// @mui
import { Stack, StackProps } from '@mui/material';
import { ArticleProps } from 'src/@types/article';
import { AdvertisementProps } from '../../@types/advertisement';
// @types
import { AuthorProps } from '../../@types/author';
//
import { Advertisement01 } from '../advertisement';
import BlogSidebarCategories from './BlogSidebarCategories';
import BlogSidebarRecentPosts from './BlogSidebarRecentPosts';

// ----------------------------------------------------------------------

interface Props extends StackProps {
  author?: AuthorProps;
  categories: any;
  recentPosts: {
    list: ArticleProps[];
    path: string;
  };
  advertisement: AdvertisementProps;
}

export default function BlogSidebar({
  categories,
  recentPosts,
  advertisement,
  sx,
  ...other
}: Props) {
  // const isDesktop = useResponsive('up', 'md');

  return (
    <>
      {/* {author && isDesktop && <BlogSidebarAuthor author={author} />} */}

      {/* {isDesktop && <SearchInput />} */}

      <Stack
        spacing={5}
        sx={{
          // pt: { md: 5 },
          pb: { xs: 8, md: 5 },
          ...sx,
        }}
        {...other}
      >
        {categories && <BlogSidebarCategories categories={categories} />}
        {recentPosts && <BlogSidebarRecentPosts recentPosts={recentPosts} />}
        {/* <BlogSidebarPopularTags /> */}
        <Advertisement01 advertisement={advertisement} />
      </Stack>
    </>
  );
}
